import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component '" + name + "' was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2>{`DRONES`}</h2>
    <p>{`In the aftermath of natural disasters, quick access to the affected areas to assess the situation is one of the main challenges faced by humanitarian organisations. This is where drones come in. With the ability to be deployed within minutes of a disaster, drones can easily gather the necessary information in a safe and effective way.`}</p>
    <p>{`In 2019, the EU supported WFP with vital funding for its logistics operations in `}<strong parentName="p">{`Mozambique`}</strong>{` in the wake of Cyclone Idai and subsequent flooding. The EU’s contribution helped WFP strengthen early warning systems and preparedness in the country, in part by training technical staff of the National Institute of Disaster Management (INGC) to use drones to quickly gather data to assess damage and needs.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      